import Vue from 'vue'

import userHead from './userHead'
import userFoot from './userFoot'
import MapContainer from './MapContainer'

const install = function(Vue) {
  Vue.component(userHead.name, userHead)
  Vue.component(userFoot.name, userFoot)
  Vue.component(MapContainer.name, MapContainer)
}
export default install